import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useReducer } from "react";
import { APIKeysView } from "./APIKeys";
import { NodeEdgeMapper } from "@iotv/datamodel-core";
import { getNodeEdgeMapperReducer, NodeEdgeMapperContext } from "../../../ContextProviders/NodeEdgeMapperComponentContext";
import { AppMainViewContext } from "../../../ContextProviders/AppContextProvider";
import { Typography } from "@mui/material";
import { getApiKeysRecordsForCustomer } from "./data/getApiKeys";
import { isValidBusinessObject } from "@iotv/iotv-v3-types";
const debug = process.env.REACT_APP_DEBUG && false;
export const APIKeyView = (props) => {
    const nodeEdgeReducer = getNodeEdgeMapperReducer({ canaryString: 'APIKeyView' });
    const [state, dispatch] = useReducer(nodeEdgeReducer, { nodeEdgeMapper: new NodeEdgeMapper(), nemHash: null, apexNode: null });
    const [{ contextCustomer },] = useContext(AppMainViewContext);
    const getApiKeys = async (contextCustomer) => {
        const { err, data } = await getApiKeysRecordsForCustomer(contextCustomer);
        if (err) {
            debug && console.log('Error fetching API keys for customer', err);
            return [];
        }
        else if (data) {
            debug && console.log('Fetched API keys for customer', data);
            const loadableItesms = data.Items?.filter(isValidBusinessObject) ?? [];
            dispatch({ type: 'loadItems', value: { items: loadableItesms } });
        }
        return [];
    };
    useEffect(() => {
        console.log('APIKeyView contextCustomer', contextCustomer);
        if (contextCustomer) {
            getApiKeys(contextCustomer);
            dispatch({ type: 'setApexNode', value: { apexNode: contextCustomer } });
        }
    }, [contextCustomer]);
    return _jsx(NodeEdgeMapperContext.Provider, { value: { dispatch, state }, children: _jsx(APIKeyViewInternal, { contextCustomer: contextCustomer }) });
};
const APIKeyViewInternal = ({ contextCustomer }) => {
    return _jsxs("div", { children: [_jsx(Typography, { variant: "h5", children: "API Keys" }), contextCustomer ? _jsx(APIKeysView, { contextCustomer }) : _jsx(Typography, { variant: "body1", children: "No customer context available." })] });
};
